/**
 * Joins strings to format IDs for compound components.
 * Note: This does not guarantee a *unique* ID.
 */
export function makeId(...args: (string | number | null | undefined)[]) {
  return args.filter((val) => val != null).join('--');
}
